// extracted by mini-css-extract-plugin
module.exports = {"orderPlaced":"qM","checkoutSpinner":"rM","active":"sM","checkoutBody":"tM","showOnlySmallScreen":"uM","hideSmallScreen":"vM","leftCol":"wM","rightCol":"xM"};